import { lazy } from 'react';

export const CompareCourseTracksPage = lazy(() => import('./controller.js'));
